import { injectCompanyToURL } from '@helpers'

import Api from '../api'
import type { MessageToAccountantPayload } from './types'
import { API_MESSAGE_TO_ACCOUNTANT_TOPICS_URL, API_MESSAGE_TO_ACCOUNTANT_URL } from './urls'

export function fetchMessageToAccountantTopics(companyId: Company['id']) {
  return Api.get(injectCompanyToURL(API_MESSAGE_TO_ACCOUNTANT_TOPICS_URL, companyId))
}

export function createMessageToAccountant(companyId: Company['id'], payload: MessageToAccountantPayload) {
  return Api.post(injectCompanyToURL(API_MESSAGE_TO_ACCOUNTANT_URL, companyId), payload)
}
